var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.initImg != false)?_c('div',{staticClass:"init-img-wrapper"},[_c('img',{attrs:{"src":_vm.initImg,"alt":""}})]):_vm._e(),_c('h2',{attrs:{"id":"osp-quizz-start-text"}},[_vm._v("\n        "+_vm._s(_vm.startText)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }